module.exports = __webpack_public_path__ + "img/0080.f5a1109d.png";